export function nameFormat(...words: (string | null | undefined)[]): string {
  return words
    .filter(Boolean)
    .map((word) => (word ?? '').trim())
    .join(` `);
}
